export const currenttaskConstants = {
  CURRENT_TASK_LIST_REQUEST: 'CURRENT_TASK_LIST_REQUEST',
  CURRENT_TASK_LIST_SUCCESS: 'CURRENT_TASK_LIST_SUCCESS',
  CURRENT_TASK_LIST_FAILURE: 'CURRENT_TASK_LIST_FAILURE',
  CURRENT_TASK_LIST_CHANGED: 'CURRENT_TASK_LIST_CHANGED',
  CURRENT_TASK_LIST_PAGINATION: 'CURRENT_TASK_LIST_PAGINATION'
};
